import Components from "slotworks/components/components";
import { Services } from "slotworks/services/services";

export function MaxBetMessageCommand(maxStake: number) {
    // TODO: This should be configured on, and should not change it's behaviour based on the presence of a translation
    const maxBetMessage = Services.translations.get("gen.mbw", { total_bet: Services.currency.format(maxStake), totalbet: Services.currency.format(maxStake) });
    if (maxBetMessage !== "gen.mbw") {
        Components.alert.info(maxBetMessage).execute();
    }
}
